
import { HttpClient,HttpHeaders, HttpResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ConfigurationService } from '../../_services/configuration.service';
import { UserProfileService } from '../../_services/user-profile.service';
import { UserProfile } from '../../_models/user-profile';

import { map, catchError } from 'rxjs/operators';



@Injectable()
export class WellsService {
    private url: string;
    private myheaders: HttpHeaders = new HttpHeaders();
  private options: any;
    private apiurl: any;
  private up: UserProfile;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(PLATFORM_ID) private platformid: object,
    private configurationService: ConfigurationService, private ups: UserProfileService) {
    this.ups.userProfile$.subscribe(result => {
      this.up = result;
    });

    this.url = baseUrl;
    this.apiurl = this.configurationService.config;
    }


    getHeaders() {
      this.myheaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma':'no-cache'});
        this.options = ({ headers: this.myheaders });
    }

    private handleError(error: HttpResponse<any>): Observable<any> {
    let textToReturn: string;
    if (error.status == 0) {
      textToReturn = "There was an error that may result from a network connection issue.";
    } else {
      
      textToReturn = error['error'];
      textToReturn = textToReturn.replace(/^"(.+(?="$))"$/, '$1');
    }
    return throwError(textToReturn);
    }

    getWellsInCompany(company: string): Observable<any> {
      this.getHeaders();     
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/WellGrid', this.options).pipe(   
            map(result => {
        return result;
      })
        ,catchError(this.handleError));
    }

    getFieldDatasheetDateRange(company: string,startDate:Date,endDate:Date, wellID:number): Observable<any> {
        this.getHeaders();
    
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/AvailableFieldDatasheetDateRange?startDate='
        + startDate.toDateString() + "&endDate=" + endDate.toDateString() + "&wellID=" + wellID, this.options).pipe(
            map(result => {
                              
                return result 
            })
            ,catchError(this.handleError))
    }

    getWellsStatuses(company: string): Observable<any> {
        this.getHeaders();
        return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/StatusOptions',this.options).pipe(
            map(result => {
                return result 
            })
        ,catchError(this.handleError));
    } 

    getSWDInField(company:string,fieldID:number) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells?fieldID=' + fieldID + '&isInjectionWell=true', this.options).pipe(
            map((result: any) => {
        var data = result 
        return data;
      })
          ,catchError(this.handleError));
    }

    getFieldsInCompany(company: string) {
      this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Fields?companyName=' + company, this.options).pipe(      
            map(result => {
        return result 
      })
        ,catchError(this.handleError));
    }

    getLookUpValues(company: string, groupName: string) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Utilities/Lookup/' + groupName + '?companyName=' + company, this.options).pipe(
            map(result => {
        return result 
      })
         ,catchError(this.handleError));
    }

    createWell(company: string, well: any, effectiveDate: Date, hydrate:boolean) {
       
        delete well.EffectiveDate;
        delete well.CloneWellID;
        delete well.hydrate;
               
        this.getHeaders();   
      return this.http.put(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells?effectiveDate=' + effectiveDate.toDateString() + '&shouldHydrate=' + hydrate, well, this.options).pipe(
            map(result => {
        return result 
      })
        ,catchError(this.handleError));
    }

    getWellCloneInfo(company:string , wellid:number) {
        this.getHeaders();     
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/' + wellid, this.options).pipe(
        map(result => {

          return result 
        })
         ,catchError(this.handleError));

    }

    getPlateInfo(company: string) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/PlateInfo?plateDiameter=null&plateSize=null', this.options).pipe(
        map(result => {
          return result 
        })
        , catchError(this.handleError));
    }

    getBatteriesInField(company: string, fieldid: number): Observable<Array<any>> {
        this.getHeaders();
        return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/FieldBatteries?fieldID=' + fieldid, this.options).pipe(
            map(result => {
                return result 
            })
            ,catchError(this.handleError))
}

    getGasFacilitiesInField(company: string, fieldid: number): Observable < Array < any >> {
     this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/GasFacilities?fieldID=' + fieldid, this.options).pipe(
          map(result => {
        return result 
      })
         ,catchError(this.handleError));
    }

    getLandPropertiesID(company: string, fieldid: number): Observable<Array<any>> {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Fields/' + fieldid + '/LandProperties?companyName=' + company, this.options).pipe(
            map(result => {
        return result 
      })
        ,catchError(this.handleError));
    }

 

    updateWellInformation(company: string, wellInfo: any,effDate:Date, shouldUpdateWellDailyProductionTable:boolean): Observable<any> {
        this.getHeaders();      
      return this.http.put(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/WellTimeline?shouldUpdateWellDailyProductionTable=' + shouldUpdateWellDailyProductionTable + "&effectiveDate=" + effDate.toDateString(), wellInfo, this.options).pipe(       
            map(result => {
        if (typeof result === "string") {
           
          return "Well Info changed successfully ";
        }
        else {
          return result 
        }
      })
        ,catchError(this.handleError));
    }

    getLandLease(company: string, fieldID:number) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Fields/' + fieldID + '/LandLeases?companyName=' + company, this.options).pipe(
            map(result => {
        return result 
      })
        ,catchError(this.handleError));
    }

    getLandUnit(company: string) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Fields/LandUnit?companyName=' + company, this.options).pipe(
         map(result => {
        return result 
      })
        ,catchError(this.handleError));
    }

    getTanks(company: string, fieldID: number, batteryID: number | null, isSkim:boolean) {
        this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Fields/' + fieldID + '/Tanks?companyName=' + company + '&batteryid=' + batteryID + '&isSkim=' + isSkim, this.options).pipe(
            map(result => {
        return result 
      })
        ,catchError(this.handleError));
  }

    getTimelineDatesForDropdown(wellid:number,company:string) {
      this.getHeaders();
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/' + wellid + '/TimelineOptions', this.options).pipe(
        map(result => {
          return result 
        })
        , catchError(this.handleError));
    }

    getTimelineEntry(wellid: number, company: string, effDate:Date) {
      this.getHeaders();
      
      return this.http.get(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/' + wellid + '/WellDataAndTimeline?date=' + effDate.toDateString(), this.options).pipe(
        map(result => {
          return result
        })
        , catchError(this.handleError));
    }

  editTimeLineEntry(company: string, well: any, effDate: Date, timelineEntryID: number, shouldHydrateDelete: boolean, wellid: number) {
    
    this.getHeaders();
    return this.http.post(this.apiurl["apiAddress"] + 'api/Companies/' + company + '/Wells/' + timelineEntryID + '/TimelineModification?effectiveDate=' + effDate.toDateString() + "&shouldHydrateDelete=" + shouldHydrateDelete + "&wellID=" + wellid, well, this.options).pipe(
      catchError(this.handleError));
  }
}
